package pt.at.oss.kotlin.manual.validator.common

import pt.at.oss.kotlin.core.enumeration.Country
import pt.at.oss.kotlin.core.enumeration.EU_COUNTRIES
import pt.at.oss.kotlin.core.enumeration.PeculiarCountry
import pt.at.oss.kotlin.core.enumeration.PeculiarCountry.Companion.findByA2
import pt.at.oss.kotlin.manual.enumeration.CustomErrorCodes
import pt.lightweightform.kotlin.type.validator.ValidationError

/**
 * Created by Pedro Alfaiate on 19/02/2021.
 */
object IdentOfBusinessValidator {
    val validateEqualCountryAndIssuer = fun(country: String?, region: String?, issuingCountry: String?, allowPT: Boolean): ValidationError? {
        val issuerIsPT = Country.PORTUGAL.codeA2 == issuingCountry
        val skip = issuerIsPT && allowPT
        val testCountry = !country.isNullOrEmpty() && !issuingCountry.isNullOrEmpty()
        val testRegion = !region.isNullOrEmpty() && !issuingCountry.isNullOrEmpty()
        return if (
            !skip && // Special case(Import scheme): Allow issuer=PT and countryOfBusiness!=PT for 980* NIFs.
            (testCountry || testRegion) &&
            !(testCountry && country == issuingCountry) &&
            !(testRegion && region == issuingCountry)
        ) ValidationError(code = CustomErrorCodes.BUSINESS_AND_ISSUING_COUNTRIES_NOT_EQUAL.code)
        else null
    }

    val validateIssuer = fun(issuingCountry: String?): ValidationError? {
        return if (!issuingCountry.isNullOrBlank() && Country.values().none { it.codeA2 == issuingCountry })
            ValidationError(code = CustomErrorCodes.ISSUER_CODE_NOT_COUNTRY.code)
        else null
    }

    // RFC-273 - XI/XU não é permitido a partir de 2023-07-01
    // XI - só é permitido se for inserido com o número VAT
    val validateIssuerNotXiXu = fun(issuingCountry: String?, vatIdNum: String?): ValidationError? {
        return if ((issuingCountry == PeculiarCountry.NORTHERN_IRELAND.codeA2 && vatIdNum.isNullOrBlank()) ||
            issuingCountry == PeculiarCountry.UK_WITHOUT_NORTH_IRELAND.codeA2
        )
            ValidationError(code = CustomErrorCodes.ISSUER_COUNTRY_XIXU_NOT_ALLOWED.code)
        else null
    }

    val validateNatTaxRefMandatoryIssuer = fun(cobRegion: String?, issuingCountry: String?): ValidationError? {

        if (issuingCountry.isNullOrBlank()) {
            return null
        }

        // Since some regions are also in Country,
        // we need to check whether cobRegion and issuingCountry are regions.

        val region = findByA2(cobRegion) ?: findByA2(issuingCountry) ?: return null
        if (cobRegion.isNullOrBlank() && region.issuerMode == PeculiarCountry.IssuerMode.PARENT) {
            return ValidationError(
                code = CustomErrorCodes.COB_REGION_SHOULD_BE_USED.code,
                data = mapOf(
                    "parentA2" to region.parentA2,
                    "regionA2" to region.codeA2
                )
            )
        }

        return when {
            region.issuerMode == PeculiarCountry.IssuerMode.PARENT
                && issuingCountry != region.parentA2
            -> ValidationError(code = CustomErrorCodes.ISSUER_COUNTRY_NOT_EQUAL_PARENT.code)

            region.issuerMode == PeculiarCountry.IssuerMode.REGION
                && issuingCountry != region.codeA2
            -> ValidationError(code = CustomErrorCodes.ISSUING_COUNTRY_NOT_EQUAL_REGION.code)

            region.issuerMode == PeculiarCountry.IssuerMode.ANY &&
                issuingCountry == region.parentA2
                && EU_COUNTRIES.any { it.codeA2 == issuingCountry }
            -> ValidationError(code = CustomErrorCodes.ISSUING_COUNTRY_MS_IS_EU_COUNTRY.code)

            else -> null
        }
    }
}
